import { Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import AuthLogo from "../../Components/Auth/AuthLogo";
import AuthCard from "../../Components/Auth/AuthCard";
import AuthContainer from "../../Components/Auth/AuthContainer";
import CustomInput from "../../Components/Custom/CustomInput";
import CustomButton from "../../Components/Custom/CustomButton";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import { ErrorHandler, SuccessToast } from "utils/toast";
import { forgotPassword } from "slices/thunks";
import { useNavigate } from "react-router-dom";
import { VALIDATION_MESSAGES } from "Components/constants/validation";

const ForgetPasswordPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isLoading } = useAppSelector((state) => state?.auth);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(VALIDATION_MESSAGES.REQUIRED("Your Email"))
        .email(VALIDATION_MESSAGES.INVALID_EMAIL),
    }),
    onSubmit: async (values) => {
      try {
        const res = await dispatch(
          forgotPassword(values?.email?.trim())
        )?.unwrap();
        SuccessToast(res?.message);
        navigate("/login", { replace: true });
      } catch (error) {
        ErrorHandler(error);
      }
    },
  });

  document.title = "Reset Password | EaziQuote";
  return (
    <ParticlesAuth>
      <AuthContainer>
        <Container>
          <Row>
            <Col lg={12}>
              <AuthLogo />
            </Col>
          </Row>
          <Row className="auth-container">
            <Col md={8} lg={6} xl={5}>
              <AuthCard>
                <div className="text-center mt-2">
                  <h5 className="text-black2D font-primary fw-semibold fs-24">
                    Forgot Password?
                  </h5>
                  <p className="font-primary fs-14 text-grey89 fw-normal">
                    No worries! Just enter your email, and we’ll help you reset
                    your password.
                  </p>
                </div>
                <div className="p-2">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                    }}
                  >
                    <CustomInput
                      label="Email"
                      placeholder="Enter your email"
                      name="email"
                      type="email"
                      value={validation.values.email}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      touched={validation.touched.email}
                      error={validation.errors.email}
                      required
                    />
                    <CustomButton
                      text="Send Now"
                      type="submit"
                      className="auth-Button"
                      loading={isLoading}
                      disabled={isLoading}
                    />
                  </form>
                </div>
              </AuthCard>
            </Col>
          </Row>
        </Container>
      </AuthContainer>
    </ParticlesAuth>
  );
};

export default ForgetPasswordPage;
